/**
 * Side Cart Wrapper Component
 * 
 * Wrapper that connects SideCart to the cart context.
 * Handles checkout navigation.
 */

'use client';

import { useCartContext } from '@/lib/context/cart-context';
import { env } from '@/lib/utils/env';
import { trackCheckoutStartedFromCart } from '@/lib/analytics';
import { useCart } from '@/lib/hooks/use-cart';
import { resolveRuntimeAppUrl } from '@/lib/utils/runtime-app-url';
import { SideCart } from './SideCart';
import { FunnelCartBanner } from './FunnelCartBanner';

export function SideCartWrapper() {
  const { cartToken, setCartToken, isCartOpen, hideCart, clearCart } = useCartContext();
  const { data: cart } = useCart(cartToken, clearCart);

  const handleCheckout = (token: string) => {
    hideCart();
    if (cart?.items.length) {
      trackCheckoutStartedFromCart({
        cartToken: token,
        currency: cart.currency,
        lines: cart.items,
        shippingCents: cart.totals?.shipping?.display,
        taxCents: cart.totals?.taxes?.display,
      });
    }
    window.location.href = resolveRuntimeAppUrl(`${env.CHECKOUT_URL}/checkout/${token}`);
  };

  const handleCartUpdate = (newToken: string) => {
    if (newToken !== cartToken) {
      setCartToken(newToken);
    }
  };

  return (
    <SideCart
      cartToken={cartToken}
      isOpen={isCartOpen}
      onClose={hideCart}
      onCheckout={handleCheckout}
      onCartUpdate={handleCartUpdate}
      onCartCompleted={clearCart}
      summaryVariant="credits-bar"
      slots={{
        topBanner: <FunnelCartBanner />,
      }}
    />
  );
}
